// extracted by mini-css-extract-plugin
module.exports = {"containerCustom":"styles_containerCustom__28b4Z","colInfo":"styles_colInfo__1eFaw","colLogin":"styles_colLogin__2anE4","offerBubble":"styles_offerBubble__2fhUt"};